import React, { PropsWithChildren } from 'react'
import { AnalyticsElement } from '@typesApp/Analytics'
import { useAppTranslation } from '@hooks/useAppTranslation'
import { IconAnchor } from '@components/foundation/icon-anchor/IconAnchor'
import { injectAnalytics } from '@utils/analyticsAttributes'
import { injectDataAttributes } from '@utils/dataAttributes'
import styles from '../styles/ContactUsPanel.module.scss'

type ActionProps = {
  analyticsIndex: number
  noIcon?: boolean
  noPreLink?: boolean
} & PropsWithChildren

export const CallUsAction: React.FC<ActionProps> = ({ analyticsIndex, noIcon, noPreLink, children }) => {
  const { t } = useAppTranslation()

  return (
    <IconAnchor
      href={`tel:${t('ContactInfo.phone')}`}
      underline
      iconProps={noIcon ? undefined : { library: 'base', name: 'phone' }}
      preLink={noPreLink ? undefined : t('ContactInfo.phone-prelink')}
      preLinkClassName={noPreLink ? undefined : styles.preLink}
      {...injectDataAttributes('contactUs.phone')}
      {...injectAnalytics(AnalyticsElement.MORE_INFO, { index: analyticsIndex })}
    >
      {!children && <span className={styles.linkText}>{t('ContactInfo.phone-label')}</span>}
      {children}
    </IconAnchor>
  )
}
